import * as Api from "../api";

/**
 * Feature flags servidos por la API (`GET /api/feature-flags`).
 *
 * Son sólo de presentación: indican qué flujo debe renderizar el frontend.
 * El backend no los consulta — los endpoints de WhatsApp siguen habilitados
 * sin importar el valor del flag.
 */

export const TOKU_SUBSCRIPTION = 'toku_subscription';
export const WHATSAPP_VERIFICATION = 'whatsapp_verification';

// Si la API no responde caemos a false y el front renderiza el flujo
// anterior (sin verificación por WhatsApp), que siempre es válido.
const DEFAULTS = {
    [TOKU_SUBSCRIPTION]: false,
    [WHATSAPP_VERIFICATION]: false
};

class FeatureFlags {
    constructor() {
        this.flags = Object.assign({}, DEFAULTS);
        this.request = null;
    }

    /**
     * Una sola petición por carga de página: las llamadas siguientes
     * reutilizan la misma promesa.
     */
    load() {
        if (!this.request) {
            this.request = Api.GetFeatureFlags()
                .then(response => {
                    if (response && response.success && response.flags) {
                        Object.keys(DEFAULTS).forEach(code => {
                            if (typeof response.flags[code] === 'boolean') {
                                this.flags[code] = response.flags[code];
                            }
                        });
                    }
                    return this.flags;
                })
                .catch(() => this.flags);
        }
        return this.request;
    }

    /**
     * Lectura síncrona. Devuelve false mientras `load()` no haya resuelto.
     */
    isEnabled(code) {
        return this.flags[code] === true;
    }
}

export default new FeatureFlags();
